// Splide
document.querySelectorAll('.mm-bh__splide').forEach(function (el) {
  if (!el.classList.contains('mm-is-initialized')) {
      try {
          el.classList.add('mm-is-initialized');
          const splide = new Splide(el);

          splide.on('mounted', function () {
              el.querySelectorAll('.splide__slide--clone').forEach(function (slide) {
                  slide.setAttribute('aria-hidden', 'true');
                  slide.setAttribute('tabindex', '-1');
                  slide.querySelectorAll('h1').forEach(function (heading) {
                      const replacement = document.createElement('div');
                      replacement.innerHTML = heading.innerHTML;

                      Array.from(heading.attributes).forEach(function (attr) {
                          replacement.setAttribute(attr.name, attr.value);
                      });

                      heading.replaceWith(replacement);
                  });
              });
          });

          splide.mount();
      } catch (e) {
          console.warn('Splide init error:', e);
      }
  }
});

// Décalage section sous la search bar (mobile uniquement)
(function () {
    const section = document.querySelector('.mm-banner-hero-section');
    const headerSearch = document.querySelector('.js-header__search');
    if (!section || !headerSearch) return;

    const breakpoint = window.matchMedia('(max-width: 989px)');

    function updateOffset() {
        if (!breakpoint.matches) {
            section.style.paddingTop = '';
            return;
        }
        const searchHidden = headerSearch.classList.contains('header__search--hidden');
        section.style.paddingTop = searchHidden ? '' : '48px';
    }

    updateOffset();
    new MutationObserver(updateOffset).observe(headerSearch, { attributes: true, attributeFilter: ['class'] });
    breakpoint.addEventListener('change', updateOffset);
})();


